import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  saveEnabled = false;
  static targets = [
    'image',
    'colorOne',
    'colorOneValue',
    'colorTwo',
    'colorTwoValue',
    'colorThree',
    'colorThreeValue',
    'buttonGroup',
    'saveButton',
    'selectedFont',
  ];

  //Need to get the form elements to pass onto the end point.

  initialize() {}

  fontSelect(event) {
    const { image, font } = event.params;
    this.imageTarget.src = image;
    this.selectedFontTarget.value = font;
    const buttons = this.buttonGroupTarget.children;
    for (let index = 0; index < buttons.length; index++) {
      buttons[index].classList.remove('text-white', 'bg-blue-1', 'border-blue-1');
      buttons[index].classList.add('border-black');
    }

    event.currentTarget.classList.remove('border-black');
    event.currentTarget.classList.add('text-white', 'bg-blue-1', 'border-blue-1');
    // this.activateSave();
  }

  colorSelect(event) {
    const { color1, color2, color3 } = event.params;
    const change = new Event('change');

    this.colorOneValueTarget.value = '#' + color1;
    this.colorTwoValueTarget.value = '#' + color2;
    this.colorThreeValueTarget.value = '#' + color3;

    this.colorOneValueTarget.dispatchEvent(change);
    this.colorTwoValueTarget.dispatchEvent(change);
    this.colorThreeValueTarget.dispatchEvent(change);
  }

  colorChange(event) {
    const color = event.target.value;
    const id = event.params.id;

    switch (id) {
      case 'colorOne':
        this.updateColorPickers(this.colorOneTarget, color);
        break;
      case 'colorTwo':
        this.updateColorPickers(this.colorTwoTarget, color);
        break;
      case 'colorThree':
        this.updateColorPickers(this.colorThreeTarget, color);
        break;
      default:
        break;
    }
    // this.activateSave();
  }

  saveChanges() {
    const saveData = {
      font: this.selectedFontTarget.value,
      colors: [this.colorOneValueTarget.value, this.colorTwoValueTarget.value, this.colorThreeValueTarget.value],
    };
    console.log(saveData);
  }

  activateSave() {
    if (!this.saveEnabled) {
      this.saveButtonTarget.classList.remove('bg-gray-3');
      this.saveButtonTarget.classList.add('bg-blue-1', 'hover:bg-blue-2', 'cursor-pointer');
      this.saveButtonTarget.disabled = false;
      this.saveEnabled = true;
    }
  }

  updateColorPickers(element, color) {
    element.getElementsByClassName('embedded-color-box')[0].innerHTML = color;
    element.getElementsByClassName('embedded-color-swatch')[0].style.backgroundColor = color;
  }
}
